import { getAuth, User, signInAnonymously } from "firebase/auth";
import { amplitude } from "./third-party";
import { app } from "./firebaseApp";
import { useEffect, useState } from "react";
import { useMainStore } from "../common/store";

export const auth = getAuth(app);

export function useLoggedInSync() {
  const setIsLoggedIn = useMainStore((state) => state.setIsLoggedIn);
  const [initialLoading, setInitialLoading] = useState(true);

  useEffect(() => {
    void signInAnonymously(auth);
  }, []);

  useEffect(() => {
    function onStateChange(user: User | null) {
      if (user) {
        amplitude.setUserId(user.uid);
        setIsLoggedIn(true);
        setInitialLoading(false);
      }
    }
    return auth.onAuthStateChanged((user) => onStateChange(user));
  }, [setIsLoggedIn, setInitialLoading]);

  return initialLoading;
}
